import {img} from '@/utils/pluginImg.js'
import {getWaitingItemIcon} from '@/utils/airports'

/**
 * Icon for a `/config/airports` waiting_times item.
 *
 * The API sends a label and minutes, never an icon. `getWaitingItemIcon()` maps the
 * label to a filename — the SAME mapping the plugin uses, so both portals show the
 * same icon for the same row — and `img()` resolves it out of assets/images (the
 * same folder `@img/index.js` exports from, just keyed by filename).
 */
export function waitingItemImage(name) {
    return img(getWaitingItemIcon(name))
}

export default waitingItemImage
